import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { Store } from '@ngrx/store';
import { ToggleTerminal } from '../../../stores/ui/ui.actions';

@Component({
  selector: 'era-terminal-toggle',
  templateUrl: './terminal-toggle.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FaIconComponent],
})
export class TerminalToggleContainerComponent {
  private readonly store = inject(Store);

  public openTerminal(): void {
    this.store.dispatch(new ToggleTerminal({ isOpen: true }));
  }
}
